import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "dataPointsList", "dataPointTemplate", "chartType", "pointCount"]

  connect() {
    this.pointIndex = this.dataPointsListTarget.querySelectorAll(".data-point-card").length
  }

  addDataPoint() {
    const template = this.dataPointTemplateTarget.innerHTML
    const newPoint = template.replace(/INDEX/g, this.pointIndex.toString())

    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = newPoint
    const card = tempDiv.firstElementChild

    this.dataPointsListTarget.appendChild(card)
    this.pointIndex++
    this.updatePointCount()

    // Focus the label input
    const labelInput = card.querySelector("input[type='text']")
    if (labelInput) labelInput.focus()
  }

  removeDataPoint(event) {
    const card = event.target.closest(".data-point-card")
    if (!card) return

    const currentCount = this.dataPointsListTarget.querySelectorAll(".data-point-card").length
    if (currentCount <= 2) return

    card.remove()
    this.updatePointCount()
  }

  updateChartType() {
    // Could show/hide chart-type-specific options in the future
  }

  updatePointCount() {
    const count = this.dataPointsListTarget.querySelectorAll(".data-point-card").length
    if (this.hasPointCountTarget) {
      this.pointCountTarget.textContent = `${count} points`
    }
  }
}
